<template>
<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
<path d="M9.75 3.75H15.75M9.75 9H15.75M9.75 14.25H15.75M2.25 12.75L3.75 14.25L6.75 11.25M2.25 5.25L3.75 6.75L6.75 3.75" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>
